import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import { PXTextModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXTextModalWrapper';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

export const Layout = () => {
  const { resource, saving } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  return (
    <PXTextModalWrapper
      additionalActions={
        resource.withRelationship(fr.relationships.skip.name, (rel) => {
          return (
            <FDSecondaryActionButton
              {...dataAttrs('skip-btn', resource)}
              loading={saving}
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
              label={"I'll do this later"}
            />
          );
        }, () => null)
      }
    >
      <MetaControlField attr={'description'} />
    </PXTextModalWrapper>
  );
};
